import { ICsvImportTemplateProps } from '@/imports/ui/components/csv/CsvImportTemplate';

export enum UserCsvHeaders {
  FIRST_NAME = 'First Name',
  LAST_NAME = 'Last Name',
  USERNAME = 'Username',
  EMAIL = 'Email',
  ADDRESS = 'Address',
  CITY = 'City',
  COUNTRY = 'Country',
  POSTAL_CODE = 'Postal Code',
  STATE = 'State',
  EXTERNAL_ID = 'External Id',
  PHONE_NUMBER = 'Phone Number',
  COMPANY = 'Organization',
  JOB_TITLE = 'Job Title',
  MODERATED_BY_DEFAULT = 'Moderated By Default',
  UNSUBSCRIBE_FROM_EMAILS = 'Unsubscribe From Emails',
  UNSUBSCRIBE_FROM_PM_NOTIFICATIONS = 'Unsubscribe From PM Notifications',
  UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS = 'Unsubscribe From @ Notifications',
  MEMBER_STATUS = 'Member Status',
  DEACTIVATED = 'Archived',
  INHERIT_MEMBERSHIP_FROM_COMPANY = 'Inherit Membership From Company',
  MEMBERSHIP_TYPE = 'Membership Type',
  MEMBERSHIP_TERM_START_DATE = 'Membership Term Start Date (MM/DD/YYYY)',
  MEMBERSHIP_TERM_END_DATE = 'Membership Term End Date (MM/DD/YYYY)',
  PAYMENT_DUE = 'Payment Due',
  ROLE = 'Role',
  MEMBER_SINCE = 'Member Since (MM/DD/YYYY)',
  HIDE_FROM_MEMBER_DIRECTORY = 'Hide From Member Directory',
  PRIVATE_COMMUNITY_PROFILE = 'Private Community Profile',
}

type USER_BULK_IMPORT_NON_MM =
  | UserCsvHeaders.FIRST_NAME
  | UserCsvHeaders.LAST_NAME
  | UserCsvHeaders.USERNAME
  | UserCsvHeaders.EMAIL
  | UserCsvHeaders.ADDRESS
  | UserCsvHeaders.CITY
  | UserCsvHeaders.COUNTRY
  | UserCsvHeaders.POSTAL_CODE
  | UserCsvHeaders.STATE
  | UserCsvHeaders.EXTERNAL_ID
  | UserCsvHeaders.PHONE_NUMBER
  | UserCsvHeaders.COMPANY
  | UserCsvHeaders.JOB_TITLE
  | UserCsvHeaders.MODERATED_BY_DEFAULT
  | UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS
  | UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS
  | UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS
  | UserCsvHeaders.MEMBER_STATUS
  | UserCsvHeaders.DEACTIVATED
  | UserCsvHeaders.ROLE
  | UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY
  | UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE;

type USER_BULK_IMPORT_MM =
  | UserCsvHeaders.FIRST_NAME
  | UserCsvHeaders.LAST_NAME
  | UserCsvHeaders.USERNAME
  | UserCsvHeaders.EMAIL
  | UserCsvHeaders.ADDRESS
  | UserCsvHeaders.CITY
  | UserCsvHeaders.COUNTRY
  | UserCsvHeaders.POSTAL_CODE
  | UserCsvHeaders.STATE
  | UserCsvHeaders.EXTERNAL_ID
  | UserCsvHeaders.PHONE_NUMBER
  | UserCsvHeaders.COMPANY
  | UserCsvHeaders.JOB_TITLE
  | UserCsvHeaders.MODERATED_BY_DEFAULT
  | UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS
  | UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS
  | UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS
  | UserCsvHeaders.DEACTIVATED
  | UserCsvHeaders.ROLE
  | UserCsvHeaders.INHERIT_MEMBERSHIP_FROM_COMPANY
  | UserCsvHeaders.MEMBERSHIP_TYPE
  | UserCsvHeaders.MEMBERSHIP_TERM_START_DATE
  | UserCsvHeaders.MEMBERSHIP_TERM_END_DATE
  | UserCsvHeaders.PAYMENT_DUE
  | UserCsvHeaders.MEMBER_SINCE
  | UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY
  | UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE;

export const REQUIRED_USER_HEADERS_FOR_INSERT = [
  UserCsvHeaders.FIRST_NAME,
  UserCsvHeaders.LAST_NAME,
];

const NON_MEMBER_MANAGEMENT_USER_UPLOAD_TEMPLATE: ICsvImportTemplateProps<
  Record<USER_BULK_IMPORT_NON_MM, string>
> = {
  filename: 'user_template.csv',
  rows: [
    {
      [UserCsvHeaders.FIRST_NAME]: 'Jerome',
      [UserCsvHeaders.LAST_NAME]: 'Seinfeld',
      [UserCsvHeaders.USERNAME]: 'Jerry Seinfeld',
      [UserCsvHeaders.EMAIL]: 'jerry-official@gmail.com',
      [UserCsvHeaders.ADDRESS]: '123 Maple Street',
      [UserCsvHeaders.CITY]: 'Anytown',
      [UserCsvHeaders.COUNTRY]: 'US',
      [UserCsvHeaders.POSTAL_CODE]: '17101',
      [UserCsvHeaders.STATE]: 'PA',
      [UserCsvHeaders.EXTERNAL_ID]: 'abcd',
      [UserCsvHeaders.JOB_TITLE]: 'stand-up comedian',
      [UserCsvHeaders.COMPANY]: 'Seinfeld',
      [UserCsvHeaders.PHONE_NUMBER]: '0123456789',
      [UserCsvHeaders.MODERATED_BY_DEFAULT]: 'false',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS]: 'false',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS]: 'false',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS]: 'false',
      [UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: 'false',
      [UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: 'false',
      [UserCsvHeaders.MEMBER_STATUS]: 'Member',
      [UserCsvHeaders.DEACTIVATED]: 'false',
      [UserCsvHeaders.ROLE]: 'Regular User',
    },
    {
      [UserCsvHeaders.FIRST_NAME]: 'Marie',
      [UserCsvHeaders.LAST_NAME]: 'Curie',
      [UserCsvHeaders.USERNAME]: 'Marie Curie',
      [UserCsvHeaders.EMAIL]: 'marie-curie@gmail.com',
      [UserCsvHeaders.ADDRESS]: '',
      [UserCsvHeaders.CITY]: '',
      [UserCsvHeaders.COUNTRY]: '',
      [UserCsvHeaders.POSTAL_CODE]: '',
      [UserCsvHeaders.STATE]: '',
      [UserCsvHeaders.EXTERNAL_ID]: '',
      [UserCsvHeaders.JOB_TITLE]: '',
      [UserCsvHeaders.COMPANY]: '',
      [UserCsvHeaders.PHONE_NUMBER]: '',
      [UserCsvHeaders.MODERATED_BY_DEFAULT]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS]: '',
      [UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: '',
      [UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: '',
      [UserCsvHeaders.MEMBER_STATUS]: '',
      [UserCsvHeaders.DEACTIVATED]: '',
      [UserCsvHeaders.ROLE]: 'Admin',
    },
    {
      [UserCsvHeaders.FIRST_NAME]: 'Michael',
      [UserCsvHeaders.LAST_NAME]: 'Scott',
      [UserCsvHeaders.USERNAME]: 'Michael Scott',
      [UserCsvHeaders.EMAIL]: 'michael-scott@gmail.com',
      [UserCsvHeaders.ADDRESS]: '',
      [UserCsvHeaders.CITY]: '',
      [UserCsvHeaders.COUNTRY]: '',
      [UserCsvHeaders.POSTAL_CODE]: '',
      [UserCsvHeaders.STATE]: '',
      [UserCsvHeaders.EXTERNAL_ID]: '',
      [UserCsvHeaders.JOB_TITLE]: '',
      [UserCsvHeaders.COMPANY]: 'Dunder Mifflin',
      [UserCsvHeaders.PHONE_NUMBER]: '',
      [UserCsvHeaders.MODERATED_BY_DEFAULT]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS]: '',
      [UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: '',
      [UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: '',
      [UserCsvHeaders.MEMBER_STATUS]: '',
      [UserCsvHeaders.DEACTIVATED]: '',
      [UserCsvHeaders.ROLE]: 'Company Account Owner',
    },
    {
      [UserCsvHeaders.FIRST_NAME]: 'Dwight',
      [UserCsvHeaders.LAST_NAME]: 'Schrute',
      [UserCsvHeaders.USERNAME]: 'Dwight Schrute',
      [UserCsvHeaders.EMAIL]: 'dwight-schrute@gmail.com',
      [UserCsvHeaders.ADDRESS]: '',
      [UserCsvHeaders.CITY]: '',
      [UserCsvHeaders.COUNTRY]: '',
      [UserCsvHeaders.POSTAL_CODE]: '',
      [UserCsvHeaders.STATE]: '',
      [UserCsvHeaders.EXTERNAL_ID]: '',
      [UserCsvHeaders.JOB_TITLE]: '',
      [UserCsvHeaders.COMPANY]: 'Dunder Mifflin',
      [UserCsvHeaders.PHONE_NUMBER]: '',
      [UserCsvHeaders.MODERATED_BY_DEFAULT]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS]: '',
      [UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: '',
      [UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: '',
      [UserCsvHeaders.MEMBER_STATUS]: '',
      [UserCsvHeaders.DEACTIVATED]: '',
      [UserCsvHeaders.ROLE]: 'Company Page Admin',
    },
  ],
};

const MEMBER_MANAGEMENT_USER_UPLOAD_TEMPLATE: ICsvImportTemplateProps<
  Record<USER_BULK_IMPORT_MM, string>
> = {
  filename: 'user_template.csv',
  rows: [
    {
      [UserCsvHeaders.FIRST_NAME]: 'Jerome',
      [UserCsvHeaders.LAST_NAME]: 'Seinfeld',
      [UserCsvHeaders.USERNAME]: 'Jerry Seinfeld',
      [UserCsvHeaders.EMAIL]: 'jerry-official@gmail.com',
      [UserCsvHeaders.ADDRESS]: '123 Maple Street',
      [UserCsvHeaders.CITY]: 'Anytown',
      [UserCsvHeaders.COUNTRY]: 'US',
      [UserCsvHeaders.POSTAL_CODE]: '17101',
      [UserCsvHeaders.STATE]: 'PA',
      [UserCsvHeaders.EXTERNAL_ID]: 'abcd',
      [UserCsvHeaders.JOB_TITLE]: 'stand-up comedian',
      [UserCsvHeaders.COMPANY]: 'Seinfeld',
      [UserCsvHeaders.PHONE_NUMBER]: '0123456789',
      [UserCsvHeaders.MODERATED_BY_DEFAULT]: 'false',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS]: 'false',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS]: 'false',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS]: 'false',
      [UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: 'false',
      [UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: 'false',
      [UserCsvHeaders.DEACTIVATED]: 'false',
      [UserCsvHeaders.ROLE]: 'Regular User',
      [UserCsvHeaders.INHERIT_MEMBERSHIP_FROM_COMPANY]: 'false',
      [UserCsvHeaders.MEMBERSHIP_TYPE]: 'Student Membership',
      [UserCsvHeaders.MEMBERSHIP_TERM_START_DATE]: '10/27/2021',
      [UserCsvHeaders.MEMBERSHIP_TERM_END_DATE]: '10/27/2025',
      [UserCsvHeaders.MEMBER_SINCE]: '02/03/1998',
      [UserCsvHeaders.PAYMENT_DUE]: 'No',
    },
    {
      [UserCsvHeaders.FIRST_NAME]: 'Marie',
      [UserCsvHeaders.LAST_NAME]: 'Curie',
      [UserCsvHeaders.USERNAME]: 'Marie Curie',
      [UserCsvHeaders.EMAIL]: 'marie-curie@gmail.com',
      [UserCsvHeaders.ADDRESS]: '',
      [UserCsvHeaders.CITY]: '',
      [UserCsvHeaders.COUNTRY]: '',
      [UserCsvHeaders.POSTAL_CODE]: '',
      [UserCsvHeaders.STATE]: '',
      [UserCsvHeaders.EXTERNAL_ID]: '',
      [UserCsvHeaders.JOB_TITLE]: '',
      [UserCsvHeaders.COMPANY]: '',
      [UserCsvHeaders.PHONE_NUMBER]: '',
      [UserCsvHeaders.MODERATED_BY_DEFAULT]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS]: '',
      [UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: '',
      [UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: '',
      [UserCsvHeaders.DEACTIVATED]: '',
      [UserCsvHeaders.ROLE]: 'Admin',
      [UserCsvHeaders.INHERIT_MEMBERSHIP_FROM_COMPANY]: '',
      [UserCsvHeaders.MEMBERSHIP_TYPE]: '',
      [UserCsvHeaders.MEMBERSHIP_TERM_START_DATE]: '',
      [UserCsvHeaders.MEMBERSHIP_TERM_END_DATE]: '',
      [UserCsvHeaders.MEMBER_SINCE]: '',
      [UserCsvHeaders.PAYMENT_DUE]: '',
    },
    {
      [UserCsvHeaders.FIRST_NAME]: 'Michael',
      [UserCsvHeaders.LAST_NAME]: 'Scott',
      [UserCsvHeaders.USERNAME]: 'Michael Scott',
      [UserCsvHeaders.EMAIL]: 'michael-scott@gmail.com',
      [UserCsvHeaders.ADDRESS]: '',
      [UserCsvHeaders.CITY]: '',
      [UserCsvHeaders.COUNTRY]: '',
      [UserCsvHeaders.POSTAL_CODE]: '',
      [UserCsvHeaders.STATE]: '',
      [UserCsvHeaders.EXTERNAL_ID]: '',
      [UserCsvHeaders.JOB_TITLE]: '',
      [UserCsvHeaders.COMPANY]: 'Dunder Mifflin',
      [UserCsvHeaders.PHONE_NUMBER]: '',
      [UserCsvHeaders.MODERATED_BY_DEFAULT]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS]: '',
      [UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: '',
      [UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: '',
      [UserCsvHeaders.DEACTIVATED]: '',
      [UserCsvHeaders.ROLE]: 'Company Account Owner',
      [UserCsvHeaders.INHERIT_MEMBERSHIP_FROM_COMPANY]: 'true',
    },
    {
      [UserCsvHeaders.FIRST_NAME]: 'Dwight',
      [UserCsvHeaders.LAST_NAME]: 'Schrute',
      [UserCsvHeaders.USERNAME]: 'Dwight Schrute',
      [UserCsvHeaders.EMAIL]: 'dwight-schrute@gmail.com',
      [UserCsvHeaders.ADDRESS]: '',
      [UserCsvHeaders.CITY]: '',
      [UserCsvHeaders.COUNTRY]: '',
      [UserCsvHeaders.POSTAL_CODE]: '',
      [UserCsvHeaders.STATE]: '',
      [UserCsvHeaders.EXTERNAL_ID]: '',
      [UserCsvHeaders.JOB_TITLE]: '',
      [UserCsvHeaders.COMPANY]: 'Dunder Mifflin',
      [UserCsvHeaders.PHONE_NUMBER]: '',
      [UserCsvHeaders.MODERATED_BY_DEFAULT]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_EMAILS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_PM_NOTIFICATIONS]: '',
      [UserCsvHeaders.UNSUBSCRIBE_FROM_AT_MENTION_NOTIFICATIONS]: '',
      [UserCsvHeaders.HIDE_FROM_MEMBER_DIRECTORY]: '',
      [UserCsvHeaders.PRIVATE_COMMUNITY_PROFILE]: '',
      [UserCsvHeaders.DEACTIVATED]: '',
      [UserCsvHeaders.ROLE]: 'Company Page Admin',
      [UserCsvHeaders.INHERIT_MEMBERSHIP_FROM_COMPANY]: '',
    },
  ],
};

export const getUserUploadTemplate = (
  memberManagementEnabled: boolean
): ICsvImportTemplateProps<Record<USER_BULK_IMPORT_MM, string>> => {
  return memberManagementEnabled
    ? MEMBER_MANAGEMENT_USER_UPLOAD_TEMPLATE
    : NON_MEMBER_MANAGEMENT_USER_UPLOAD_TEMPLATE;
};

const BULK_ARCHIVE_EMAIL_TEMPLATE: ICsvImportTemplateProps<
  Record<string, string>
> = {
  filename: 'user_archive_email_template.csv',
  rows: [{ [UserCsvHeaders.EMAIL]: 'jerry-official@gmail.com' }],
};

export const getUserDeactivateUploadTemplate = (): ICsvImportTemplateProps<
  Record<string, string>
> => {
  return BULK_ARCHIVE_EMAIL_TEMPLATE;
};
